import { useState, useRef } from "react";
import { useTranslation } from "next-i18next";
import { Modal, Button } from "antd";
import { useRouter } from "next/router";
import { useAppSelector } from "@/store/hooks";
import { RootState } from "@/store/index";
import defaultSettings from "@/config/settings";
import Icon from "../Icon";
import Certificate from "./Certificate";
import { IAwardInfo, IUserStats } from "@/props/IDonation";
import { toPng } from "html-to-image";

const CertificateDownloadModal = ({
  open,
  onModalCancel,
  awardInfo,
  onClickDownload,
  userStats,
}: {
  open: boolean;
  onModalCancel: (open: boolean) => void;
  onClickDownload: Function;
  awardInfo: IAwardInfo;
  userStats: IUserStats;
}) => {
  const { t } = useTranslation();
  const [hasName, setHasName] = useState<boolean>(false);
  const { pcModalWidth } = defaultSettings;
  const { isSmallScreen } = useAppSelector((state: RootState) => state.app);
  const appStore = useAppSelector((state: RootState) => state.app);
  const { isMobile } = appStore;
  const certRef = useRef<HTMLDivElement>(null);

  // 下载图片
  const handleDownloadImage = async () => {
    if (!certRef.current) return;
    const dataUrl = await toPng(certRef.current, {
      pixelRatio: window.devicePixelRatio,
      cacheBust: true,
    });
    const a = document.createElement("a");
    a.href = dataUrl;
    a.download = "certificate.png";
    a.click();
  };

  return (
    <>
      <Modal
        title={`${t("csr.download_certificate")}`}
        open={open}
        footer={null}
        width={isSmallScreen ? 343 : pcModalWidth}
        onCancel={() => {
          onModalCancel(false);
        }}
        closeIcon={!isSmallScreen ? <Icon name="close" size={24} title="icon close" /> : null}
        maskClosable={false}
      >
        <div className="mt-0 flex flex-col items-center border-t-0 border-gray-100 pt-0 md:mt-4 md:border-t md:pt-6">
          <div ref={certRef}>
            <Certificate userStats={userStats} fromModal={true} hasName={hasName} awardInfo={awardInfo} />
          </div>
        </div>
        <div className={`mb-2 mt-5 ${isMobile ? "flex flex-col" : "flex items-center"}`}>
          {isMobile && (
            <div className="mb-4 flex items-center">
              <Icon
                name={hasName ? "checked" : "check"}
                size={16}
                aria-hidden="true"
                onClick={() => {
                  setHasName(!hasName);
                }}
              />
              <span className="ml-2">{t("csr.show_name")}</span>
            </div>
          )}

          <div className={`flex w-full ${isMobile ? "justify-center" : "items-center"}`}>
            {!isMobile && (
              <div className="ml-5 flex flex-1">
                <Icon
                  name={hasName ? "checked" : "check"}
                  size={16}
                  aria-hidden="true"
                  onClick={() => {
                    setHasName(!hasName);
                  }}
                />
                <span className="ml-2">{t("csr.show_name")}</span>
              </div>
            )}

            <div className={`flex ${isMobile ? "gap-3" : ""}`}>
              <Button
                type="primary"
                className={`${isMobile ? "" : "mr-4"} min-w-[80px]`}
                ghost
                onClick={() => {
                  onModalCancel(false);
                }}
                style={{ height: "36px" }}
              >
                {t("common.cancel")}
              </Button>
              <Button
                type="primary"
                className="min-w-[80px]"
                onClick={() => {
                  handleDownloadImage();
                  onClickDownload({
                    eventId: 1,
                    showRealName: hasName ? 1 : 0,
                  });
                }}
                style={{ height: "36px" }}
              >
                {t("csr.download")}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CertificateDownloadModal;
